"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var moment_1 = __importDefault(require("moment"));
var RangePicker_style_1 = require("./RangePicker.style");
exports.RangePicker = function (_a) {
    var max = _a.max, config = _a.config, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange;
    var valueInitRef = react_1.useRef(false);
    var hashedListRef = react_1.useRef({});
    var _b = react_1.useState([]), list = _b[0], setList = _b[1];
    var _c = react_1.useState(getWord(defaultValue)), activeItem = _c[0], setActiveItem = _c[1];
    react_1.useEffect(function () {
        setupList();
    }, [max, config]);
    react_1.useEffect(function () {
        if (valueInitRef.current) {
            setupValue();
        }
        if (!valueInitRef.current) {
            valueInitRef.current = true;
        }
    }, [value]);
    function setupList() {
        var time = moment_1.default();
        var newList = config
            .sort(function (a, b) {
            return moment_1.default().subtract(b.value, b.type).unix() - moment_1.default().subtract(a.value, a.type).unix();
        })
            .reduce(function (p, c) {
            var key = getWord(c);
            var rangeEnd = time.clone();
            var rangeStart = time.clone().subtract(c.value, c.type);
            var rangeMax = !max ? -1 : time.clone().subtract(max.value, max.type).unix();
            hashedListRef.current[key] = {
                disabled: max && rangeMax > rangeStart.unix(),
                diff: getDiff(rangeStart, rangeEnd),
                value: c.value,
                type: c.type,
                key: key
            };
            return __spreadArrays(p, [
                hashedListRef.current[key]
            ]);
        }, []);
        setList(newList);
    }
    function setupValue() {
        if (!value) {
            return setActiveItem(undefined);
        }
        var time = moment_1.default();
        var activeItem;
        var diff = getDiff(moment_1.default.unix(value), time);
        Object.keys(hashedListRef.current).forEach(function (key) {
            var item = hashedListRef.current[key];
            return diff !== item.diff ? null : activeItem = item.key;
        });
        setActiveItem(activeItem);
    }
    function getDiff(rangeStart, rangeEnd) {
        var rangeDiff = rangeEnd.diff(rangeStart, 'days');
        var type = 'D';
        if (rangeDiff > 0) {
            return "" + rangeDiff + type;
        }
        rangeDiff = rangeEnd.diff(rangeStart, 'hours');
        type = 'H';
        if (rangeDiff > 0) {
            return "" + rangeDiff + type;
        }
        rangeDiff = rangeEnd.diff(rangeStart, 'minutes');
        type = 'm';
        return "" + rangeDiff + type;
    }
    function getWord(item) {
        if (!item) {
            return;
        }
        switch (item.type) {
            case 'minute':
            case 'minutes':
                return item.value + "m";
            case 'hour':
            case 'hours':
                return item.value + "H";
            case 'day':
            case 'days':
                return item.value + "D";
            case 'week':
            case 'weeks':
                return item.value + "W";
            case 'month':
            case 'months':
                return item.value + "M";
        }
    }
    function handleRangeClick(range) {
        setActiveItem(range.key);
        if (!onChange) {
            return;
        }
        var time = moment_1.default();
        var rangeEnd = time.clone().unix();
        var rangeStart = time.clone().subtract(range.value, range.type).unix();
        onChange([rangeStart, rangeEnd]);
    }
    return (react_1.default.createElement(RangePicker_style_1.RangePickerContainer, null, list
        .map(function (range) {
        return (react_1.default.createElement(RangePicker_style_1.RangePickerItem, { key: range.key, children: range.key, disabled: range.disabled, active: activeItem === range.key, onClick: function () { return handleRangeClick(range); } }));
    })));
};
//# sourceMappingURL=RangePicker.js.map